import { api } from 'api';
import { getIn18Text } from 'api';
const sysApi = api.getSystemApi();
export const isCurrentUser = (item) => {
    var _a, _b, _c, _d, _e, _f;
    const id = ((_a = item) === null || _a === void 0 ? void 0 : _a.id) || ((_c = (_b = item) === null || _b === void 0 ? void 0 : _b.contact) === null || _c === void 0 ? void 0 : _c.id);
    return id === ((_f = (_e = (_d = sysApi.getCurrentUser()) === null || _d === void 0 ? void 0 : _d.contact) === null || _e === void 0 ? void 0 : _e.contact) === null || _f === void 0 ? void 0 : _f.id);
};
const rootNameText = {
    enterprise: 'QIYETONGXUNLU',
    personal: 'GERENTONGXUNLU',
    recent: 'ZUIJINLIANXIREN',
    team: 'WODEQUNZU',
    customer: 'myCustomer',
    clue: 'myClue',
    orgBtn: 'XUANZEZUZHI',
    teamBtn: 'XUANZEQUNZU',
    personalOrgBtn: 'XUANZEFENZU',
    select: 'XUANZE',
    allPersonal: 'SUOYOULIANXIREN',
    markPersonalList: 'markContactAndOrg',
    noGroupPersonal: 'WEIFENZULIANXI',
    rencentSendMail: 'ZUIJINFAGUOXIN',
    memberList: 'CHAKANCHENGYUANXIN',
    notVisible: 'contact_tree_not_visible',
    contactAdmin: 'contact_tree_contact_admin',
    noContact: 'ZANWULIANXIREN',
};
export const transTreeName = (name) => {
    return getIn18Text(rootNameText[name]);
};
